document.addEventListener('turbolinks:load', function() {
    const bookTitleInput = document.getElementById('book_title');
    const bookAuthorsInput = document.getElementById('book_authors');
    const bookIsbnInput = document.getElementById('book_isbn');
    const previewImageHiddenInput = document.getElementById('book_preview_image');
    const titleAutocompleteList = document.getElementById('title-autocomplete-list');
    const existingBookWarning = document.getElementById('existing-book-warning');


    if (bookTitleInput !== null && titleAutocompleteList !== null) {
        bookTitleInput.addEventListener('input', handleTitleInput);
        bookTitleInput.addEventListener('change', handleTitleInputChange);
        bookIsbnInput.addEventListener('input', handleIsbnInput);
    }

    async function handleTitleInput() {
        const length = this.value.length;
        const MIN_INPUT_LENGTH = 3;
        if (length > MIN_INPUT_LENGTH){
            const booksList = await getBooksList(this.value);
            const booksListCount = booksList.length;
            titleAutocompleteList.innerHTML = '';
            for (let i = 0; i < booksListCount; i++){
                if (booksList[i] !== null){
                    const autocompleteItem = generateAutocompleteItemElement(booksList[i]);
                    titleAutocompleteList.append(autocompleteItem);
                }
            }
        }else{
            titleAutocompleteList.innerHTML = '';
        }
    }

    async function handleTitleInputChange() {
        await showOrHideExistingBookWarning(bookTitleInput.value)
        titleAutocompleteList.innerHTML = '';
    }

    async function handleIsbnInput() {
        const length = this.value.length;
        const MIN_INPUT_LENGTH = 3;
        if (length > MIN_INPUT_LENGTH){
            const booksList = await getBooksList(this.value, 'isbn');
            const booksListCount = booksList.length;
            titleAutocompleteList.innerHTML = '';

            if (booksListCount === 1) {
                const bookDetails = booksList[0];
                bookTitleInput.value = bookDetails.title;
                bookAuthorsInput.value = bookDetails.authors;
                bookIsbnInput.value = bookDetails.isbn;

                await handleTitleInputChange();
                return;
            }

            for (let i = 0; i < booksListCount; i++){
                if (booksList[i] !== null){
                    const autocompleteItem = generateAutocompleteItemElement(booksList[i]);
                    titleAutocompleteList.append(autocompleteItem);
                }
            }
        }else{
            titleAutocompleteList.innerHTML = '';
        }
    }

    function convertHttpToHttps(link) {
        if (link === undefined || link === null) return '';

        const regex = /http:/i
        return link.replace(regex, 'https:');
    }

    function getBestPreviewImage(imageLinks) {
        if (imageLinks === undefined || imageLinks === null) return '';

        const PRIORITY_LIST = ['large', 'medium', 'small', 'thumbnail', 'smallThumbnail'];

        for (let index = 0; index < PRIORITY_LIST.length; index++) {
            const imageType = PRIORITY_LIST[index];
            if (imageLinks[imageType]){
                return convertHttpToHttps(imageLinks[imageType]);
            }
        }

        return '';
    }

    function getISBN(industryIdentifiers) {
        if (!Array.isArray(industryIdentifiers)) return '';

        let isbn10 = '';
        let isbn13 = '';

        for (let index = 0; index < industryIdentifiers.length; index++){
            const industryIdentifier = industryIdentifiers[index];
            if (industryIdentifier === undefined || industryIdentifier === null) {
                continue;
            }

            if (industryIdentifier.type === 'ISBN_10'){
                isbn10 = industryIdentifier.identifier || '';
            }else if (industryIdentifier.type === 'ISBN_13'){
                isbn13 = industryIdentifier.identifier || '';
            }
        }

        if (isbn13 && isbn13.length > 0) {
            return isbn13;
        }else if (isbn10 && isbn10.length > 0){
            return isbn10;
        }else return '';
    }

    async function getBooksList(searchTerm, queryField = 'intitle'){
        const BASE_URL = 'https://www.googleapis.com/books/v1/volumes?key=AIzaSyBz20nz6BB2ipB1-ZjC036ohxWAuC5CQS4';
        const rawResponse = await fetch(BASE_URL + '&printTypes=books&projection=full&q=' + queryField + ':' + encodeURI(searchTerm));
        if (rawResponse && rawResponse.ok){
            const response = await rawResponse.json();

            if (response && response.items) {
                return response.items.map(item => {
                    if (item && item.volumeInfo && item.volumeInfo.authors && item.volumeInfo.title) {
                        return {
                            title: item.volumeInfo.title,
                            authors: item.volumeInfo.authors.join(', '),
                            previewImage: getBestPreviewImage(item.volumeInfo.imageLinks),
                            isbn: getISBN(item.volumeInfo.industryIdentifiers)
                        };
                    }
                    return null;
                });
            }
            return [];
        }
        return [];
    }

    function generateAutocompleteItemElement(itemData) {
        const autocompleteItem = document.createElement('div');
        autocompleteItem.setAttribute('class', 'autocomplete-item');

        const imagePreview = document.createElement('img');
        imagePreview.setAttribute('class', 'autocomplete-item-preview-image');
        imagePreview.setAttribute('loading', 'lazy');
        if (itemData.previewImage){
            imagePreview.src = itemData.previewImage;
        }else{
            
            imagePreview.src = '/assets/no-preview-image-d7145b265cd51583c1f31341bce20143d8a60e19496f3bda3c2928f1373c54a0.jpg';
        }

        const bookTitleAndAuthorWrapperDiv = document.createElement('div');

        const title = document.createElement('h5');
        title.innerText = itemData.title;

        const authors = document.createElement('p');
        authors.innerText = itemData.authors;

        bookTitleAndAuthorWrapperDiv.append(title);
        bookTitleAndAuthorWrapperDiv.append(authors);

        autocompleteItem.append(imagePreview);
        autocompleteItem.append(bookTitleAndAuthorWrapperDiv);

        const item = document.createElement('a');
        item.setAttribute('href', '#');
        item.setAttribute('class', 'list-group-item list-group-item-action');
        item.setAttribute('data-title', itemData.title);
        item.setAttribute('data-authors', itemData.authors);
        item.setAttribute('data-isbn', itemData.isbn);
        item.setAttribute('data-image', itemData.previewImage);
        item.addEventListener('click', handleAutocompleteItemSelect);

        item.append(autocompleteItem);

        return item;
    }

    async function handleAutocompleteItemSelect (item) {
        item.preventDefault();

        try{
            const title = item.currentTarget.getAttribute('data-title');
            const authors = item.currentTarget.getAttribute('data-authors');
            const isbn = item.currentTarget.getAttribute('data-isbn');
            const previewImage = item.currentTarget.getAttribute('data-image');

            bookTitleInput.value = title;
            bookAuthorsInput.value = authors;
            bookIsbnInput.value = isbn;
            previewImageHiddenInput.value = previewImage;

            await handleTitleInputChange();

        }catch(e){
            console.error(e);
        }
    }

    async function checkIfBookExists (title) {
        const BASE_URL = '/api/check_if_book_exist';
        const rawResponse = await fetch(BASE_URL + '?title=' + encodeURI(title));
        if (rawResponse && rawResponse.ok){
            const response = await rawResponse.json();

            if (response && response.result) {
                return response.result;
            }
            return false;
        }
        return false;
    }

    async function showOrHideExistingBookWarning (title) {
        const bookExists = await checkIfBookExists(title);
        if(bookExists){
            existingBookWarning.classList.remove('d-none');
        }else{
            existingBookWarning.classList.add('d-none');
        }
    }
});